import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useContentAsociacionUsuariosNomatividad = () => {
  const [asociacionUsuariosNomatividad, setAsociacionUsuariosNomatividad] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getAsociacionUsuariosNomatividad = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent("asociacionusuariosnormatividad");
      setAsociacionUsuariosNomatividad(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(" ERROR EN useContentAsociacionUsuariosNomatividad --> ", error);
    }
  };

  useEffect(() => {
    getAsociacionUsuariosNomatividad();
  }, []);

  return {
    asociacionUsuariosNomatividad 
  };
};

export default useContentAsociacionUsuariosNomatividad;
